<script setup lang="ts">
import { RouterView } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { onMounted } from 'vue';

const authStore = useAuthStore();

onMounted(async () => {
  // Check if user is already logged in
  await authStore.checkAuth();
});
</script>

<template>
  <RouterView />
</template>
